import type { FC } from 'react';
import {
  Box,
  Stack,
  Breadcrumbs,
  Link,
  Typography,
  SxProps,
  Theme,
} from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

interface IProps {
  breadcrumbs: { href?: string; title: string }[];
  breadcrumbSx?: SxProps<Theme>;
}

const CustomBreadcrumbs: FC<IProps> = ({ breadcrumbs, breadcrumbSx }) => {
  return (
    <Box
      alignItems={'flex-start'}
      sx={{
        display: {
          xs: 'none',
          sx: 'none',
          md: 'flex',
        },
        ...breadcrumbSx,
      }}
    >
      <Stack spacing={2}>
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
        >
          {breadcrumbs?.map((item) =>
            item?.href ? (
              <Link
                underline="hover"
                key={item.title}
                color="inherit"
                href={item.href}
              >
                {item?.title}
              </Link>
            ) : (
              <Typography key={item.title} sx={{ color: 'text.primary' }}>
                {item?.title}
              </Typography>
            ),
          )}
        </Breadcrumbs>
      </Stack>
    </Box>
  );
};

export default CustomBreadcrumbs;
